import { Grid, Icon, Typography} from '@material-ui/core';
import React from 'react';
import resumeData from '../../utils/resumeDate';
import CustomTimeline, {
  CustomTimelineSeparator,
} from '../../components/Timeline/Timeline';
import WorkIcon from '@material-ui/icons/Work';
import SchoolIcon from '@material-ui/icons/School';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineItem from '@material-ui/lab/TimelineItem';
import useStyles from './style';
import Zoom from 'react-reveal/Zoom';

const Resume = () => {

  const classes = useStyles()

  return (
    <div className={classes.root}>
      
    <Zoom>
      
      <Grid container className={classes.section}>

        {/* Title */}
        <Grid item className={classes.sectionTitle}>
          <span className={classes.span} />
          <h6 className={classes.sectionTitleText}>Resume</h6>
        </Grid>

        {/* Education & Experiance */}
        <Grid item xs={12}>
          <Grid container className={classes.resumeTimeline}>
            
            {/* Experiance */}
            <Grid item sm={12} md={6}>
              <CustomTimeline title="Work Experiance" icon={<WorkIcon />}>
                {resumeData.experiance.map (experiance => (
                  <TimelineItem>
                    <CustomTimelineSeparator />
                    <TimelineContent className={classes.timelineContent}>
                      <Typography className={classes.timelineTitle}>
                        {' '}{experiance.title}{' '}
                      </Typography>
                      <Typography variant="caption" className={classes.timelineDate}>
                        {' '}{experiance.date}{' '}
                      </Typography>
                      <Typography
                        variant="body2"
                        className={classes.timelineDescription}
                      >
                        {' '}{experiance.description}{' '}
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                ))}
              </CustomTimeline>
            </Grid>

            {/* Education */}
            <Grid className={classes.education} item sm={12} md={6}>
              <CustomTimeline title="Education" icon={<SchoolIcon />}>
                {resumeData.educations.map (educations => (
                  <TimelineItem>
                    <CustomTimelineSeparator />
                    <TimelineContent className={classes.timelineContent}>
                      <Typography className={classes.timelineTitle}>
                        {' '}{educations.title}{' '}
                      </Typography>
                      <Typography variant="caption" className={classes.timelineDate}>
                        {' '}{educations.date}{' '}
                      </Typography>
                      <Typography
                        variant="body2"
                        className={classes.timelineDescription}
                      >
                        {' '}{educations.description}{' '}
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                ))}
              </CustomTimeline>
            </Grid>

          </Grid>
        </Grid>
      </Grid>

      {/* Services */}
      <Grid container className={classes.serviceSection}>
        <Grid item className={classes.sectionTitle}>
          <span className={classes.span} />
          <h6 className={classes.sectionTitleText}>My Services</h6>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={3} justify="space-around">
            {resumeData.services.map (service => (
              <Grid item xs={12} sm={6} md={3}>
                <div className={classes.service}>
                  <Icon className={classes.serviceIcon}>{service.icon}</Icon>
                  <Typography variant="h6" className={classes.serviceTitle}>
                    {service.title}
                  </Typography>
                  <Typography variant="body2" className={classes.serviceDescription}>
                    {service.description}
                  </Typography>
                </div>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>

      </Zoom>
      
    </div>
  );
};

export default Resume;
